import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Time = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Time' {...props}>
    <path d='M1 13H5L7.5 4L12.5 20.5L17 9L19 13H23' stroke='#000' strokeWidth='2' />
  </StyledIcon>
);
